export default __webpack_public_path__ + "static/media/file.2dddbe81.svg";